'use strict';

angular.module('shop').controller('ShopController', function($rootScope, $window, $location, CustomerService, CUSTOMER) {
	
	$rootScope.publicShop = false;
	
	// Check if customer should use public shop or not
	if (CUSTOMER) {
		CustomerService.get().then(function (customer) {
			var url = $location.absUrl();
			if (!url.includes('/mypage/') && customer.hasAccessToMyPage) {
				$window.location.href = '/mypage/shop/';
			}
		});
	} else {
		$rootScope.publicShop = true;
	}

	$rootScope.$on('$stateChangeSuccess', function() {
		document.body.scrollTop = document.documentElement.scrollTop = 0;
	});

});